import styles from './feature.module.css'



const Feature = (props) =>
{
	return (
		<>
			<div className={styles.container}>
				<div className={styles.logo} dangerouslySetInnerHTML={props.icone}></div>
				<h3 className={styles.head}>{props.heading}</h3>
				<div className={styles.description}>
					{props.content}
				</div>
			</div>
		</>
	)
}

export default Feature